import React, { useState, useContext } from 'react';
import { Modal, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { Button, ButtonToolbar, ButtonGroup } from '@/shared/components/Button';
import ModalNew from '@/shared/components/Modal';
import EditBooking from './EditBooking';
import loadRazorpayScript from '../../../RazorPay/razorpayUtils';
import { GlobalContext } from '../../../../../context/GlobalContext';
import { BookingContext } from '../../../../../context/BookingContext';
import ConfirmationModal from '../ConfirmationModal';
import Payment from '../../../Payment';
import { AuthContext } from '../../../../../context/AuthContext';
import { PermissionContext } from '../../../../../context/PermissionContext';
import RejectReasonForm from './RejectReasonForm';







const PendingCard = ({
 bookingData, paxDetailsHandler, setPaxDetailsHandler, setRefresh, 
}) => {
       const [showEditModal, setShowEditModal] = useState(false);
       const [agentID, setAgentID] = useState();
       const [confirmBokingModal, setConfirmBookingModal] = useState(false);
       const [showRejectBookingModal, setShowRejectBookingModal] = useState(false);
       const [bookingID, setBookinigID] = useState();
       const [amount, setAmount] = useState(0);
       const [orderidpg, setOrderidpg] = useState('');
       const [showPayment, setShowPayment] = useState(false);
       const { apiGlobal } = useContext(GlobalContext);
       const {
 agentId, userId, currencyType, currencyCode, countryId,
} = useContext(AuthContext);
       const { tripDataFlag, setTripDataFlag } = useContext(BookingContext);
       const { permissionsAccess } = useContext(PermissionContext);
       const [disabledButton, setDisabledButton] = useState(false);
      //  console.log(bookingData);

       const history = useHistory();
       const editModalHandler = (agentid, bookingid) => {
        setAgentID(agentid);
        setBookinigID(bookingid);
        setShowEditModal(true);
       };

       const addMealHandler = (tripid, tripname) => {
        history.push('/agent/meal');
        setTripDataFlag({
          ...tripDataFlag,
          tripID: tripid,
          name: tripname,
          addMealINBooking: true,
        });
       };










   const handleEditTrip = async (value) => {
    // console.log(value);
    const utcStartDate = value.startDates;
      const utcEndDate = value.endDate;

      const startDate = new Date(utcStartDate);
      const endDate = new Date(utcEndDate);

        if (startDate >= endDate) {
           toast.error('Start date must be earlier than end date');
           return; // Or any other action you'd like to perform
         }

      const istOffset = 5.5 * 60 * 60 * 1000;
      const startDateIST = new Date(startDate.getTime() + istOffset);
     const endDateIST = new Date(endDate.getTime() + istOffset);  

     // Format the dates (DD-MM-YYYY)
     const formatDate = dates => `${dates.getFullYear()}-${String(dates.getMonth() + 1)
      .padStart(2, '0')}-${String(dates.getDate()).padStart(2, '0')}`;

      const formattedStartDate = formatDate(startDateIST);
      const formattedEndDate = formatDate(endDateIST);

      const formattedValues = {
        pax_details: paxDetailsHandler,
    };
    
    const formattedPaxDetails = JSON.stringify(formattedValues);
  



       const formData = new FormData();
      
       formData.append('trip_id', bookingID);
       formData.append('name', value.tripName);
       formData.append('start_date', formattedStartDate);
       formData.append('end_date', formattedEndDate);
       formData.append('trip_type', value.triptype);
       formData.append('trip_ref_no', value.trip_ref_no);
      formData.append('pax_details', formattedPaxDetails);

      formData.append('type', 1);
      formData.append('user_id', userId);

    //    formData.forEach((values, key) => {
    //     console.log(`${key}: ${JSON.stringify(values)}`);
    // });

    
        

       try {
        setDisabledButton(true);
           const url = await fetch(`${apiGlobal}/agent/trip_edit.php`, {
            method: 'POST',
            body: formData,
           });
           const response = await url.json();
           if (response.status && response.message === 'Trip and Pax details updated successfully.') {
             toast.success('Trip Edit Successfull');
             setShowEditModal(false);
             setRefresh(prev => !prev);
           } else {
            toast.error('Error in updating trip details');
            setShowEditModal(true);
           }
          //  console.log(response);
       } catch (error) {
         console.log(error);
       } finally {
        setDisabledButton(false);
      }
   };
   const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty values
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };

  const openConfirmmodal = (id) => {
    setBookinigID(id);
    setConfirmBookingModal(true);
  };

  const openRejectbookingmodal = (id) => {
    setBookinigID(id);
    setShowRejectBookingModal(true);
  };

  const handleConfirmBooking = async () => {
      const formdata = new FormData();
      formdata.append('id', bookingID);
      formdata.append('isApproved', 1);
      formdata.append('type', 1);
      formdata.append('user_id', userId);
      
    try {
      const url = await fetch(`${apiGlobal}/agent/booking_confirmation.php`, {
        method: 'POST',
        body: formdata,
      });
      // console.log(url);
      const response = await url.json();
      // console.log(response);
      if (response.status && response.message === 'Success') {
        toast.success('Waiting for restaurant confirmation');
        setConfirmBookingModal(false);
        setBookinigID();
        setRefresh(prev => !prev);
      } else {
        toast.error('Error in confirming booking');
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleRejectBooking = async (value) => {
    const formdata = new FormData();
    formdata.append('id', bookingID);
    formdata.append('isApproved', 5);
    formdata.append('type', 1);
    formdata.append('user_id', userId);
    formdata.append('reason', value?.reason);

    try {
      const url = await fetch(`${apiGlobal}/agent/booking_confirmation.php`, {
        method: 'POST',
        body: formdata,
      });
      // console.log(url);
      const response = await url.json();
      // console.log(response);
      if (response.status && response.message === 'Success') {
        toast.success('Booking Rejected Successfully');
        setShowRejectBookingModal(false);
        setBookinigID();
        setRefresh(prev => !prev);
      } else {
        toast.error('Error in confirming booking');
      }
    } catch (error) {
      console.error(error);
    }
  };



  const showpaymentModal = (amt, bookingid) => {
    setShowPayment(true);
    setAmount(amt);
    setBookinigID(bookingid);
  };


   // handle payment from razorpay response
   const handlepaymentResponse = async (orderid, paymentid, bookingid, bookingAmount) => {
    if (!orderid || !paymentid || !bookingid) {
       console.log('Invalid parameters for payment response');
      return;
    }

    // console.log(bookingAmount);

    const formData = new FormData();
    formData.append('agent_id', agentId);
    formData.append('user_id', userId);
    formData.append('booking_id', bookingid);
    formData.append('order_id', orderid);
    formData.append('amount', bookingAmount / 100);
    formData.append('payment_type', '2');
     formData.append('country_id', countryId);


    try {
      const url = await fetch(`${apiGlobal}/agent/booking_payment_add.php`, {
        method: 'POST',
        body: formData,
      });
      const response = await url.json();
      if (response.status && response.message === 'Success') {
        toast.success('Payment Approved Sucessfully');
        setRefresh(prev => !prev);
        setShowPayment(false);
      } else {
        toast.error('Payment Failed');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getStatusMessage = (status) => {
    if (status === '1') return 'Awaiting approval from restaurant';
    if (status === '2') return 'Payment Pending';
    if (status === '3') return 'Awaiting payment approval';
    return 'Pending Approval';
  };

  // eslint-disable-next-line
  const storeinDb = async (orderid, bookingid, paymentid, isSucesss, reason, amount) => {
      // console.log(orderid, bookingid, paymentid, isSucesss, reason);
    if (!orderid || !paymentid) {
      return;
    }

    const formdatas = new FormData();
    formdatas.append('order_id', orderid);
    formdatas.append('booking_id', bookingid);
    formdatas.append('payment_id', paymentid);
    formdatas.append('type', 1);
    formdatas.append('is_success', isSucesss);
    formdatas.append('reason', reason);
  
    try {
      const url = await fetch(`${apiGlobal}/update_payment_id.php`, {
        method: 'POST',
        body: formdatas,
      });
      console.log(url);
      const response = await url.json();
      // console.log(response);
      if (response.status && response.message === 'Success') {
        // toast.success('Payment Done Successfully');
        // setRefresh(prev => !prev);
        // setShowPayment(false);
        await handlepaymentResponse(
               orderid,
               paymentid,
               bookingid,
                amount,
          );
      } else {
        toast.error('Payment Failed');
      }
    } catch (error) {
      console.log(error);
      toast.error('Something went wrong while updating payment status.');
    }
  };


  

  const handleAddPayment = async (value) => {
    console.log(JSON.stringify(value, null, 2));


     
    // const utcpaymentDate = value.receivedDate;
    const utcChequeDate = value.chequeDate;

    // Convert to IST
    // const paymentDate = new Date(utcpaymentDate);
    const chequeDate = new Date(utcChequeDate);

    // IST offset is +5:30
    const istOffset = 5.5 * 60 * 60 * 1000;
    // const paymentDateIST = new Date(paymentDate.getTime() + istOffset);
    const chequeDateIST = new Date(chequeDate.getTime() + istOffset);

    const formatDateIST = (date) => {
      if (!date) return '';
      // eslint-disable-next-line
      date = new Date(date); // Ensure it's a Date object
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date
        .getDate()).padStart(2, '0')}`;
    };
    
    const formattedPaymentDate = formatDateIST(value.receivedDate);
    const formattedChequeDate = formatDateIST(chequeDateIST);
    

    if (value.total_amount < value.recAmount) {
      toast.error('Amount is greater than balance');
      return;
    }
  
   
    
    // If credit amount is less than received amount, show error
    // eslint-disable-next-line
// if (value.ptype.value === '4' && ) {
//   console.log('hello');
//   toast.error('Amount is greater than credit amount');
//   toast.error('Try Different Payment Type');
//   return;
// }

if (value.ptype.value === '4') {
  // eslint-disable-next-line
  const isValidAmount = parseInt(value.creditAmount) >= parseInt(value.recAmount);
  if (!isValidAmount) {
    toast.error('Amount is greater than credit amount');
    toast.error('Try Different Payment Type');
    return;
  }
}

      
 
 
 if (value.ptype.value !== '2') {
  if (!value.receivedDate) {
    toast.error('Please select a date for payment');
    return;
  }
 }

    


    // if (!value.narration) {
    //   toast.error('Please enter a narration for payment');
    //   return;
    // }

    // if (value.ptype.value === '2' && !value.ref) {
    //   toast.error('Please enter reference number');
    //   return;
    // }

   if (value.ptype.value === '3') {
 if (!value.ref || !value.bankName) {
      toast.error('Please enter reference number,bank name and Cheque Date');
      return;
    }
  }
   if (value.ptype.value === '5') {
 if (!value.chequeNo || !value.chequeDate) {
      toast.error('Please enter reference number,bank name and Cheque Date');
      return;
    }
  }

    
    


    const formData = new FormData();
    formData.append('agent_id', agentId);
    formData.append('user_id', userId);
    formData.append('booking_id', bookingID);
    formData.append('amount', value.recAmount);
    formData.append('payment_date', formattedPaymentDate);
    // formData.append('cheque_date', formattedChequeDate);
    formData.append('narration', value.narration);
    formData.append('payment_type', value.ptype.value);
     formData.append('country_id', countryId);
    
    
    if (value.ptype.value === '3') {
      formData.append('ref_no', value.ref);
      formData.append('bank', value.bankName);
    }
    if (value.ptype.value === '5') {
      formData.append('ref_no', value.chequeNo);
      formData.append('bank', value.bankName);
      formData.append('ref_date', formattedChequeDate);
    }

     // Optional: log data being sent
     formData.forEach((values, key) => {
      console.log(`${key}: ${values}`);
    });
  

    
   
    if (value.ptype.value !== '2') {
      try {
        const url = await fetch(`${apiGlobal}/agent/booking_payment_add.php`, {
          method: 'POST',
          body: formData,
        });
        const response = await url.json();
        if (response.status && response.message === 'Success') {
          toast.success('Payment Done Sucessfully');
          setRefresh(prev => !prev);
          setShowPayment(false);
        } else {
          toast.error(response.message);
        }
      } catch (error) {
        console.log(error);
      }
      // console.log('Normal Api Call');
    } else if (value.ptype.value === '2') {
       if (currencyType === '0') {
        toast.error('Please Select Currency type for procced payment');
        return;
       }

      const formdatapg = new FormData();
      formdatapg.append('agent_id', agentId);
      formdatapg.append('user_id', userId);
      formdatapg.append('booking_id', bookingID);
      formdatapg.append('type', 1);
      // eslint-disable-next-line
      formdatapg.append('currency_id', parseInt(currencyType));
      // eslint-disable-next-line
      formdatapg.append('vendorAmt', parseInt(value.total_amount));
    
      // Optional: log data being sent
      formdatapg.forEach((values, key) => {
        console.log(`${key}: ${values}`);
      });


      try {
        const url = await fetch('https://adventureplus.mvd-tech.io/rzrpay/order.php', {
          method: 'POST',
          body: formdatapg,
        });
    
        const response = await url.json();
        console.log('✅ Razorpay order response:', response);
    
        // Make sure response.id exists
        if (!response.order_id) {
          toast.error('Failed to get Razorpay order ID');
          return;
        }
       
        
        
        
        
        // Dynamically load Razorpay script
        const scriptLoaded = await loadRazorpayScript();
        if (!scriptLoaded) {
          alert('Failed to load Razorpay script');
          return;
        }
    
        // Create Razorpay options using a closure to capture response & bookingID
        const options = {
          key: response.key,
          amount: response.order_amount,
          currency: response.currency,
          contact: response.contact,
          name: response.name || 'Adventure Plus',
          description: 'Booking Payment',
          order_id: response.id,
    
          async handler(paymentResponse) {
            // console.log('✅ Payment Success:', paymentResponse);
            // console.log('➡️ Razorpay Order ID:', response.order_id); // Use response.order_id directly
            // console.log('➡️ Booking ID:', bookingID);
            // console.log('➡️ Razorpay Payment ID:', paymentResponse.razorpay_payment_id);
    
            // Save to database with the order_id from response
            await storeinDb(
              response.order_id, 
              bookingID, 
              paymentResponse.razorpay_payment_id,
              1,
              '',
              response.order_amount,
            );
            // await handlepaymentResponse(
            //   response.order_id,
            //   response.order_amount,
            //   paymentResponse.razorpay_payment_id,
            //   bookingID,
            // );
          },
    
          modal: {
            ondismiss: () => {
              console.log('❌ Payment Cancelled by User or Failed');
              toast.error('Payment was not completed.');
              setShowPayment(false);
            },
          },
    
          prefill: {
            name: response.name,
            email: response.email,
            contact: response.contact,
          },
    
          theme: {
            color: '#0f172a',
          },
        };

    
        const rzp = new window.Razorpay(options);

        
        
        rzp.open();
        rzp.on('payment.failed', async (responses) => {
          await storeinDb(
            response.order_id,
            '',
            responses.error.metadata.payment_id,
            2, // status: 2 => failure
            responses.error.description,
            response.order_amount,
          );
          console.log('❌ Payment Failed:', responses);
        });
      } catch (error) {
        console.log('🔥 Error during Razorpay setup:', error.message);
        toast.error('Something went wrong. Please try again.');
      }
    }
  };


  

  return (

    <div>
      {!bookingData ? (
        <div>Booking Data Not Passed</div> // Show message if no bookingData
      ) : (
        <div className="card mb-4 shadow-sm" style={{ maxWidth: '100%', borderColor: 'black' }}>
          <div className="card-body">
            <div className="row mb-3">
              <div className="col-md-12">
                <h5 className="fw-bold">{bookingData?.name}</h5>
              </div>
            </div>
            <div className="row mb-4">
              <div
                className="col-md-4"
                
              >
                <h6
                  className="fw-bold"
                  style={{
                display: 'flex',
                gap: 5,
              }}>Trip:<p> {bookingData?.name}-{bookingData?.trip_uin}</p>
                </h6>
              </div>
              <div className="col-md-4" style={{ display: 'flex' }}>
                <p className="mb-1">
                  <strong>Start Date:</strong> {bookingData?.start_date ? formatDate(bookingData?.start_date) : ''}
                </p>
                <p style={{ marginLeft: '12px' }}>
                  <strong>End Date:</strong> {bookingData?.end_date ? formatDate(bookingData?.end_date) : ''}
                </p>
              </div>

              <div className="col-md-4 text-end">
                {permissionsAccess?.[1]?.master_id === '2'
        && permissionsAccess?.[1]?.edit === 1 && (
          <Button 
            variant="outline-warning" 
            size="sm" 
            className="mx-1" 
            title="Edit trip"
            onClick={() => editModalHandler(bookingData?.agent_id, bookingData?.id)}
          >
            Edit Trip
          </Button>
        )}
                {permissionsAccess?.[1]?.master_id === '2'
        && permissionsAccess?.[1]?.create === 1 && (
          <Button 
            onClick={() => addMealHandler(bookingData.id, bookingData.name)} 
            variant="outline-primary" 
            size="sm" 
            className="mx-1" 
            title="Add Meal"
          >
            Add Meal
          </Button>
        )}
            
                
                
              </div>
            </div>

            {bookingData?.booking_details 
  && [...bookingData.booking_details]
    .sort((a, b) => (a.status === '0' ? -1 : 1)) // Sort meals with status '0' first
    .map((meal, index) => (
      <div className="card mb-4 shadow-sm" key={meal?.id} style={{ maxWidth: '100%' }}>
        <div className="card-body">
          {/* Meal Day Header with Actions */}
          <div className="row mb-2 align-items-center" style={{ display: 'flex' }}>
            <div className="col-md-8 d-flex align-items-center">
              <h6 className="me-2">
                {meal?.day_name} - {meal?.booking_date ? formatDate(meal?.booking_date) : ''}
                {' '} 
                <span className={String(meal?.status) === '0' ? 'text-danger' : 'text-warning'}>
                  ({String(meal?.status) === '0' ? 'Pending' : 'Awaiting Approval'})
                </span>
              </h6>

              {(meal?.status === '2' || meal?.status === '3')
  && (meal?.payment_complete_flag === 0 || meal?.payment_complete_flag === 2) && (
    <Button 
      variant="outline-success" 
      size="sm" 
      className="mx-2 mt-3" 
      title="Pay"
      onClick={() => showpaymentModal(
          meal?.payment_complete_flag === 2 ? meal?.balance : meal?.total_amount, 
          meal?.id,
        )}
      disabled={meal?.payment_flag === 0}
    >
      {meal?.payment_flag === 2 ? 'Pay Again' : 'Pay'} 
    </Button>
  )}


        

              
              {
                 permissionsAccess?.[1]?.master_id === '2'
        && permissionsAccess?.[1]?.approval === 1 && (
        <>
          <Button 
            variant="outline-success"
            size="sm"
            className="mx-2 mt-3"
            title="Approve"
            onClick={String(meal?.status) === '0' && meal?.id ? () => openConfirmmodal(meal?.id) : undefined}
            disabled={String(meal?.status) !== '0'}
          >
            {String(meal?.status) === '0' ? 'Approve' : 'Approved'}
          </Button>
          <Button 
            variant="outline-danger"
            size="sm"
            className="mx-2 mt-3"
            title="Reject"
            onClick={String(meal?.status) === '0' && meal?.id ? () => openRejectbookingmodal(meal?.id) : undefined}
            disabled={String(meal?.status) !== '0'}
          >
            Reject
          </Button>
        </>
        )
}
              
              
            </div>
          </div>
          {meal?.payment_complete_flag === 2 && (
          <p style={{
  backgroundColor: 'beige',
  borderRadius: '50px',
  margin: '12px',
  textAlign: 'center',
}}
          >
            Payment Remaining of amount   
            <span style={{
              color: 'red',
              marginLeft: '5px',
            }}
            >
              {meal?.balance}
            </span>
            
          </p>
          )}
          {meal?.payment_flag === 2 && (
          <p style={{
  backgroundColor: 'beige',
  borderRadius: '50px',
  margin: '12px',
  textAlign: 'center',
}}
          >
            Payment Reject Remark:
            <span style={{
  color: 'red',
}}
            >
              {meal?.reject_remark }
            </span>
          </p>
          )}
         
          
          {/* Meal Details */}
          <div className="row border p-3 rounded">
            <div className="col-md-3">
              <p><strong>{meal?.meal_name}/{meal?.restaurant_name}</strong></p>
              <p className="text-muted">Locations: {meal?.location}</p>
            </div>
            <div className="col-md-3">
              <p>
                <strong>Timing:</strong> 
                {{
                  1: 'Breakfast',
                  2: 'Snacks',
                  3: 'Lunch',
                  4: 'Dinner',
                }[meal?.meal_offered] || 'Unknown'}
              </p>
              <p><strong>Total Meals:</strong> {meal?.total_meal}</p>
            </div>
            <div className="col-md-3">
              <p><strong>Type:</strong>   {{
                  1: 'Fit',
                  2: 'Git',
                  3: 'Delivery',
                  // 4: 'Dinner',
                }[meal?.meal_format] || 'Unknown'}
              </p>
              <p><strong>Format:</strong> {meal?.meal_type}</p>
            </div>
            <div className="col-md-3">
              {/* <p><strong>Amount:</strong> {currencyCode} {meal?.total_amount}</p> */}
              <p><strong>Amount:</strong> AED {meal?.total_amount}</p>
              <p>
                <strong>Status: </strong> 
                <span className="text-warning">
                  <span className="text-warning">{getStatusMessage(meal?.status)}</span>

                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    ))}


            

          </div>
          <Modal
            show={showEditModal}
            onHide={() => setShowEditModal(false)}
            centered
            size="xl"
          >
            <Modal.Header closeButton>
              <Modal.Title>Edit Trip</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <EditBooking 
                onSubmit={handleEditTrip} 
                agentID={agentID} 
                bookingID={bookingID}
                setPaxDetailsHandler={setPaxDetailsHandler}
                paxDetailsHandler={paxDetailsHandler}
                disabledButton={disabledButton}
                setShowEditModal={setShowEditModal}
              /> 
              {/* <AddTrip onSubmit={handletripAdd} /> */}
            </Modal.Body>
          </Modal>
          <ConfirmationModal 
            show={confirmBokingModal}
            handleClose={() => setConfirmBookingModal(false)}
            handleDelete={handleConfirmBooking}
            header="Confirm Booking"
            message="Are you sure you want to confirm this Booking?"
            buttonType="success"
            buttonText="Confirm"
          />

          <Modal
            show={showRejectBookingModal}
            onHide={() => setShowRejectBookingModal(false)}
            size="md"
          >
            <Modal.Header
              closeButton
            >
              <Modal.Title>Add Reject Remark</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <RejectReasonForm onSubmit={handleRejectBooking} text="Booking" />
            </Modal.Body>
          </Modal>
         

          <Modal show={showPayment} onHide={() => setShowPayment(false)} size="xl">
            <Modal.Header closeButton>
              <Modal.Title>Make Payment</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Payment amount={amount} bookingid={bookingID} onSubmit={handleAddPayment} />
            </Modal.Body>
          </Modal> 

        </div>

    
)}
    </div>
  );
}; 

PendingCard.propTypes = {
  bookingData: PropTypes.shape({
    id: PropTypes.string.isRequired, 
    agent_id: PropTypes.string.isRequired, 
    name: PropTypes.string.isRequired, 
    trip_uin: PropTypes.string.isRequired,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
    booking_details: PropTypes.arrayOf(PropTypes.shape({


    })).isRequired,
  }).isRequired, 
  paxDetailsHandler: PropTypes.arrayOf(
    PropTypes.shape({
    }),
  ).isRequired,
  setPaxDetailsHandler: PropTypes.func.isRequired,
  setRefresh: PropTypes.func.isRequired,
};



export default PendingCard;

